<div class="tab-container">
    <div class="sensor-container" *ngFor="let sensor of model.temperatureSensorsHelperList, let i = index">
        <div class="sensor-row">
            <div class="input-group">
                <label class="flex-center">{{ getCounter(i, 'SINGLE') | number:'2.0-0' }}</label>
                <div class="icon-button">
                    <i class="juc ju-delete" (click)="onRemoveBtnClicked(i)"></i>
                </div>
            </div>

            <div class="input-group col1">
                <label [for]="'sensorId' +i">ID*</label>
                <select [name]="'sensorId'+i"
                        [id]="'sensorId'+i"
                        required

                        [(ngModel)]="sensor.sensorId"
                        [ngClass]="{'no-value': sensor.sensorId===undefined}"
                        (ngModelChange)="updatedSensorIdOptionsVisibility()">
                    <option [ngValue]="undefined">Bitte auswählen</option>
                    <ng-container *ngFor="let option of getSensorIdOptionsForSensor(sensor)">
                        <option *ngIf="!option.disabled || option.value === sensor.sensorId" [ngValue]="option.value">
                            {{ option.value }}
                        </option>
                    </ng-container>
                </select>
            </div>

            <div class="input-group col2">
                <label [for]="'sensorName'+i">Sensorname*</label>
                <select [name]="'sensorName'+i"
                        [id]="'sensorName'+i"
                        required
                        [(ngModel)]="sensor.name"
                        [ngClass]="{'no-value': sensor.name===undefined}"
                        (ngModelChange)="onSensorNameChanged($event, i)">
                    <option [ngValue]="undefined" disabled>Bitte auswählen</option>
                    <ng-container *ngFor="let option of sensorNameOptions">
                        <option *ngIf="(!option.disabled || option.value === sensor.name) && !isSameTypeButNotEqualName(i, option)"
                                [ngValue]="option.value">
                            {{ isSmallScreen ? option.labelShort : option.label }}
                        </option>
                    </ng-container>
                </select>
            </div>

            <app-input-image-upload
                    [id]="'tempSensorPhoto' + getCounter(i, 'SINGLE')"
                    [name]="'tempSensorPhoto' + getCounter(i, 'SINGLE')"
                    required
                    [imageQuality]="LOW_IMAGE_QUALITY"
                    [label]="sensor?.name ? sensor.name : 'Temperatursensor'"
                    [(ngModel)]="sensor.photo">
            </app-input-image-upload>


        </div>
        <div class="sensor-row" *ngIf="sensor.pairMode === 'PAIR' || sensor.pairMode === 'TRIO'">
            <div class="input-group">
                <label class="flex-center"
                       style="height: 56px; width: 24px;">{{ getCounter(i, 'PAIR') | number:'2.0-0' }}</label>
                <!--            <div class="icon-button">-->
                <!--                <i class="juc ju-delete" (click)="onRemoveBtnClicked(i)"></i>-->
                <!--            </div>-->
            </div>

            <div class="input-group col1">
                <label [for]="'sensor2Id' +i">ID*</label>
                <select [name]="'sensor2Id'+i"
                        [id]="'sensor2Id'+i"
                        required

                        [ngClass]="{'no-value': sensor.sensor2Id===undefined}"
                        [(ngModel)]="sensor.sensor2Id"
                        (ngModelChange)="updatedSensorIdOptionsVisibility()">
                    <option [ngValue]="undefined">Bitte auswählen</option>
                    <option *ngFor="let option of getSensorIdOptionsForSensor(sensor)" [ngValue]="option.value"
                            [disabled]="option.disabled && option.value !== sensor.sensor2Id">
                        {{ option.value }}
                    </option>
                </select>
            </div>

            <div class="input-group col2">
                <label [for]="'sensorName2'+i">Sensorname*</label>
                <select [name]="'sensorName2'+i"
                        [id]="'sensorName2'+i"
                        class="disabled-select"
                        disabled
                        [(ngModel)]="sensor.name2">
                    <option *ngFor="let option of sensorNameOptions"
                            [ngValue]="option.value"
                            [disabled]="option.disabled && option.value !== sensor.name2">
                        {{ isSmallScreen ? option.labelShort : option.label }}
                    </option>
                </select>
            </div>

            <app-input-image-upload
                    [id]="'tempSensor2Photo' + getCounter(i, 'PAIR')"
                    [name]="'tempSensor2Photo' + getCounter(i, 'PAIR')"
                    required
                    [imageQuality]="LOW_IMAGE_QUALITY"
                    [label]="sensor?.name2 ? sensor.name2 : 'Temperatursensor'"
                    [(ngModel)]="sensor.photo2">
            </app-input-image-upload>

        </div>

        <div class="sensor-row trio" *ngIf="sensor.pairMode === 'TRIO'">
            <div class="input-group">
                <label class="flex-center"
                       style="height: 56px; width: 24px;">{{ getCounter(i, 'TRIO') | number:'2.0-0' }}</label>
                <!--            <div class="icon-button">-->
                <!--                <i class="juc ju-delete" (click)="onRemoveBtnClicked(i)"></i>-->
                <!--            </div>-->
            </div>

            <div class="input-group col1">
                <label [for]="'sensor3Id' +i">ID*</label>
                <select [name]="'sensor3Id'+i"
                        [id]="'sensor3Id'+i"
                        required
                        [ngClass]="{'no-value': sensor.sensor3Id===undefined}"
                        [(ngModel)]="sensor.sensor3Id"
                        (ngModelChange)="updatedSensorIdOptionsVisibility()">
                    <option [ngValue]="undefined">Bitte auswählen</option>
                    <option *ngFor="let option of getSensorIdOptionsForSensor(sensor)" [ngValue]="option.value"
                            [disabled]="option.disabled && option.value !== sensor.sensor3Id">
                        {{ option.value }}
                    </option>
                </select>
            </div>

            <div class="input-group col2">
                <label [for]="'sensorName3'+i">Sensorname*</label>
                <select [name]="'sensorName3'+i"
                        [id]="'sensorName3'+i"
                        class="disabled-select"
                        disabled
                        [(ngModel)]="sensor.name3">
                    <option *ngFor="let option of sensorNameOptions"
                            [ngValue]="option.value"
                            [disabled]="option.disabled && option.value !== sensor.name3">
                        {{ isSmallScreen ? option.labelShort : option.label }}
                    </option>
                </select>
            </div>

            <app-input-image-upload
                    [id]="'tempSensor3Photo' + getCounter(i, 'TRIO')"
                    [name]="'tempSensor3Photo' + getCounter(i, 'TRIO')"
                    required
                    [imageQuality]="LOW_IMAGE_QUALITY"
                    [label]="sensor?.name3 ? sensor.name3 : 'Temperatursensor'"
                    [(ngModel)]="sensor.photo3">
            </app-input-image-upload>

        </div>

        <div class="input-group">
            <label [for]="'customName'+i">Benutzerdefinierter Name</label>
            <input type="text"
                   [name]="'customName'+i"
                   [id]="'customName'+i"
                   [(ngModel)]="sensor.customName">
        </div>
    </div>


    <div class="button-container">
        <button class="secondary" type="button" (click)="onAddSensorBtnClicked()"
                [disabled]="model.temperatureSensorsHelperList?.length >= sensorIdOptions.length">
            <i class="ju ju-add"></i>
            Temperatursensor hinzufügen
        </button>

    </div>
</div>
<div class="field">Pflichtfelder*</div>
<app-navigation-footer
        [isBackLinkDisabled]="false"
        [backLink]="'/gateway/heating/check'"
        [isNextLinkDisabled]="!validationService.isSensorsTemperatureValid(model)"
        [nextLink]="'/gateway/sensors/pump'"
        [isLast]="false"
></app-navigation-footer>
